import { Component, EventEmitter, Input, Output, OnInit, forwardRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';


@Component({
    selector: 'app-weditor',
    templateUrl: './weditor.component.html',
    styleUrls: ['./weditor.component.scss'],
    providers: [ {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => WeditorComponent),
        multi: true
    } ]
})

export class WeditorComponent implements ControlValueAccessor, OnInit {


    @Output() onTextChange: EventEmitter<any> = new EventEmitter();

	@ViewChild('weditor') weditor: any;

    private texto: string = '';
    private cambiado;
    public modeHtmlEnable = false;

    constructor(){

    }

    private onTextChangeInternal($event){

		if($event.htmlValue === null && $event.delta && $event.delta.ops && $event.delta.ops.length > 0 && $event.delta.ops[0].insert && $event.delta.ops[0].insert.image){
			$event.htmlValue = '<p><img src="' + $event.delta.ops[0].insert.image + '"></p>';
		}
		
		this.onTextChange.emit($event);
		// this.cambiado(this.texto);
    }

    private onHtmlChangeInternal(evento){
        this.texto = evento.target.value;
        //this.cambiado(this.texto);
        this.onTextChange.emit(evento);
    }

    changeHtmlMode(_v){
        this.modeHtmlEnable = !this.modeHtmlEnable;

    }

    writeValue(obj: any): void {
        this.texto = obj;
        // throw new Error('Method not implemented.');
    }
    registerOnChange(fn: any): void {
        // this.cambiado = fn;
        // throw new Error('Method not implemented.');
    }
    registerOnTouched(fn: any): void {
        // console.log(fn);
        // throw new Error('Method not implemented.');
    }
    setDisabledState?(isDisabled: boolean): void {
        // console.log(isDisabled);
        // throw new Error('Method not implemented.');
    }

    get value(): any {
        return this.texto;
    }

    set value(v: any) {
        this.texto = v;
    }

    ngOnInit(): void { 
        // throw new Error('Method not implemented.');
    }



}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/weditor/weditor.component.ts